import creditDashboard from './credit-dashboard';

export default {
	creditDashboard,
};
